// Film-emulation grade — applies a baked Camera Raw preset as a 3D LUT.
//
// The whole grade (calibration, basic tone, curves, HSL) is evaluated on the
// CPU over a lattice by js/fx/cameraRawGrade.js and uploaded once as a
// Data3DTexture, so this pass is a single hardware-filtered lookup per pixel.
//
// Runs after OutputPass, on display-referred sRGB — which is the space the LUT
// was built in, and the only one where a Lightroom preset means anything.

precision highp sampler3D;

uniform sampler2D tDiffuse;
uniform sampler3D uLut;
uniform float     uLutSize;   // lattice edge length (e.g. 33)
uniform float     uStrength;  // 0 = untouched, 1 = full grade

in vec2 vUv;
out vec4 fragColor;

void main() {
  vec4 src = texture(tDiffuse, vUv);
  vec3 c = clamp(src.rgb, 0.0, 1.0);

  // Half-texel inset. A LUT's outer lattice points sit at 0 and 1, but texel
  // *centres* sit half a texel in — sampling the raw colour would scale the
  // whole cube by (size-1)/size and clip the top end of every channel.
  float scale = (uLutSize - 1.0) / uLutSize;
  float offset = 0.5 / uLutSize;

  vec3 graded = texture(uLut, c * scale + offset).rgb;

  fragColor = vec4(mix(src.rgb, graded, uStrength), src.a);
}
